import { useState } from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import { useFirebase } from '../../../../hooks/useFirebase';
import { queryGetBlob } from '../../../../api/tools/tools';
import { useConsultantEntityQuery } from '../../../../api/hooks/sales/useConsultantEntityQuery';
import { EntityTable } from '../../../common/entity-table/EntityTable';
import { Modal } from '../../../common/modal/Modal';
import { Button } from '../../../common/button/Button';
import { getConsultantColumnDefinition, CONSULTANT_TABS } from '../../../../schema/sales/consultant.schema';
import './sales-panels.scss';
import './confirm-dialog.scss';

export const ConsultantsPanel = () => {
  const consultantQuery = useConsultantEntityQuery();
  const { deleteConsultant, resendWelcome } = consultantQuery;
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [removeCoupons, setRemoveCoupons] = useState(false);

  const handleDelete = (consultant) => {
    setDeleteTarget(consultant);
    setRemoveCoupons(false);
  };

  const handleResend = (id) => resendWelcome(id);

  const handleDownload = async (id) => {
    const blob = await queryGetBlob(remoteConfig, `/consultants/${id}/agreement`, user?.accessToken);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'consultant-agreement.pdf';
    a.click();
    URL.revokeObjectURL(url);
  };

  const confirmDelete = () => {
    deleteConsultant({
      id: deleteTarget.id,
      removeCoupons,
      onSuccess: () => setDeleteTarget(null)
    });
  };

  // EntityTable passes (onEdit, onView, onDelete, ...) but canDelete=false so onDelete is undefined
  const wrappedColumnDef = (onEdit, onView) =>
    getConsultantColumnDefinition(onEdit, onView, handleDelete, handleResend, handleDownload);

  return (
    <>
      <EntityTable
        query={consultantQuery}
        getColumnDefinition={wrappedColumnDef}
        entityTabs={CONSULTANT_TABS()}
        entityName="Consultant"
        canDelete={false}
        canView={false}
      />

      <Modal
        title="Remove Consultant"
        isOpen={!!deleteTarget}
        onClose={() => setDeleteTarget(null)}
        width={420}
        minHeight="auto"
      >
        <div className="confirm-dialog">
          <p className="confirm-dialog__message">
            Are you sure you want to remove{' '}
            <strong>{deleteTarget?.firstName} {deleteTarget?.lastName}</strong>? This cannot be undone.
          </p>
          <label className="confirm-dialog__checkbox">
            <input
              type="checkbox"
              checked={removeCoupons}
              onChange={(e) => setRemoveCoupons(e.target.checked)}
            />
            <span>Also remove all coupon codes assigned to this consultant</span>
          </label>
          <div className="confirm-dialog__actions">
            <Button outline onClick={() => setDeleteTarget(null)}>Cancel</Button>
            <Button
              style={{ background: 'var(--status-error)', borderColor: 'var(--status-error)' }}
              loading={consultantQuery.mutating}
              onClick={confirmDelete}
            >
              Remove
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
